'use strict';

import "angular-paginate-anything";

import {EwSiteApp} from '../../app/ewsiteapp.js';

EwSiteApp.requires.push('bgf.paginateAnything');

EwSiteApp.controller('VotingIndexCtrl', ["$scope", "$sce", "$filter", "$http", "$log", function($scope, $sce, $filter, $http, $log){
	
	$scope.dataUrl = transferData.dataUrl;
	$scope.startingPage = 0;
	$scope.reloadPage = false;
	$scope.loading = false;
	$scope.questions = {
		list: []
	};
	
	function getDefaultParams(){
		return {
			title: ''
		};
	};
	$scope.filter = getDefaultParams();

	$scope.$on('pagination:loadStart', function (event, status, config) {
		$scope.loading = true;
	});
	
	$scope.$on('pagination:loadPage', function (event, status, config) {
		$scope.loading = false;
	});
	
	$scope.showClear = function(){
		return !($filter('json')($scope.filter) === $filter('json')(getDefaultParams()));
	};
	
	$scope.resetFilter = function(){
		$scope.filter = getDefaultParams();
	};
	
	$scope.explicitlyTrustedHtml = function(text) {
               return $sce.trustAsHtml(text);
	};
}]);

EwSiteApp.controller('VotingCategoryCtrl', ["$scope", "$sce", "$filter", "$http", "$log", function($scope, $sce, $filter, $http, $log){
	
	$scope.dataUrl = transferData.dataUrl;
	$scope.startingPage = 0;
	$scope.reloadPage = false;
	$scope.loading = false;
	$scope.questions = {
		list: []
	};
	
	function getDefaultParams(){
		return {
			title: ''
		};
	};
	$scope.filter = getDefaultParams();

	$scope.$on('pagination:loadStart', function (event, status, config) {
		$scope.loading = true;
	});
	
	$scope.$on('pagination:loadPage', function (event, status, config) {
		$scope.loading = false;
	});
	
	$scope.showClear = function(){
		return !($filter('json')($scope.filter) === $filter('json')(getDefaultParams()));
	};
	
	$scope.resetFilter = function(){
		$scope.filter = getDefaultParams();
	};
	
	$scope.explicitlyTrustedHtml = function(text) {
               return $sce.trustAsHtml(text);
	};
}]);

EwSiteApp.controller('VotingAnswersCtrl', ["$scope", "$http", "$log", function($scope, $http, $log) {
	$scope.dataUrl = '';
	$scope.submitUrl = '';
	$scope.answers = [];
	$scope.checkedNodesList = [];
	$scope.checkedNodes = 0;
	$scope.loading = false;
	$scope.asnwered = false;
	$scope.errors = [];
	$scope.severalAnswers = 0;
	$scope.resultsUrl = '';
	$scope.results = [];
	$scope.results_total = 0;
	
	$scope.loadData = function(){
		if($scope.dataUrl !== ''){
			$scope.loading = true;
			$http({
				method: 'GET',
				url: $scope.dataUrl
			}).then(function(response){
				$scope.loading = false;
				$scope.answers = response.data.list;
			}, function(response){
				console.log(['Error', response]);
			});
		}
	};
	
	$scope.toogleCheck = function(node){
		if($scope.severalAnswers==$scope.checkedNodes && !node.checked){
			return;
		}
		node.checked = !node.checked;
		$scope.calcChecked(node.id);
	};
	
	$scope.calcChecked = function(id){
		for(var i=0; i<$scope.answers.length; i++){
			if($scope.answers[i].id==id){
				if($scope.answers[i].checked){
					$scope.checkedNodes += 1;
				}
				else {
					$scope.checkedNodes -= 1;
				}
			}
			if($scope.severalAnswers==$scope.checkedNodes && !$scope.answers[i].checked){
				$scope.answers[i].disabled = true;
			}
		}
	};
	
	$scope.getChecked = function(level){
		for(var i=0; i<level.length; i++){
			if(level[i].checked){
				$scope.checkedNodesList.push(level[i]);
			}
		}
	};
	
	$scope.submit = function(){
		if($scope.submitUrl !== ''){
			$scope.loading = true;
			
			$scope.getChecked($scope.answers);
			
			var data = {
				answers: $scope.checkedNodesList,
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			};
			
			$http({
				method: 'POST',
				url: $scope.submitUrl,
				data: data,//$scope.checkedNodesList,
			}).then(function(response){
				$scope.loading = false;
				if(response.data.success) {
					$('#voting_answers').hide();
					$scope.asnwered = true;
					$scope.resultsUrl = response.data.results_url;
					$scope.loadResults();
				}
				else if(angular.isDefined(response.data.messages)){
					$scope.errors = response.data.messages;
					$scope.checkedNodesList = [];
				}
				if(angular.isDefined(response.data.debug)){
					$log.debug(response.data.debug);
				}
			});
//			$scope.checkedNodesList = [];
		}
	};
	
	$scope.hasErrors = function () {
		return $scope.errors.length > 0;
	};
	
	$scope.loadResults = function(){
		if($scope.resultsUrl !== ''){
			$scope.loading = true;
			$http({
				method: 'GET',
				url: $scope.resultsUrl
			}).then(function(response){
				$scope.loading = false;
				$scope.results = response.data.list;
				$scope.results_total = response.data.total;
			}, function(response){
				console.log(['Error', response]);
			});
		}
	};
	
}]).directive('answersList', function(){
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.dataUrl = '';
			scope.submitUrl = '';
			scope.severalAnswers = '';
			scope.resultsUrl = '';

			if(attr.dataUrl && attr.dataUrl !== ''){
				scope.dataUrl = unescape(attr.dataUrl);
				scope.loadData();
			}
			if(attr.resultsUrl && attr.resultsUrl !== ''){
				scope.resultsUrl = unescape(attr.resultsUrl);
				scope.loadResults();
			}
			if(attr.submitUrl && attr.submitUrl !== ''){
				scope.submitUrl = unescape(attr.submitUrl);
			}
			if(attr.severalAnswers && attr.severalAnswers !== ''){
				scope.severalAnswers = unescape(attr.severalAnswers);
			}
		}
	};
});
EwSiteApp.filter('percentage', ['$filter', function ($filter) {
  return function (input, decimals) {
    return $filter('number')(input, decimals);// + '%';
  };
}]);